var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { useSnackbar } from 'notistack';
export var useCopyToClipboard = function () {
    var _a = __read(useState(false), 2), copied = _a[0], setCopied = _a[1];
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var copyToClipboard = function (content, contentLabel) {
        navigator.clipboard
            .writeText(content)
            .then(function () {
            setCopied(true);
            enqueueSnackbar("".concat(contentLabel || 'Content', " Copied"), {
                variant: 'success'
            });
            setTimeout(function () {
                setCopied(false);
            }, 500);
        })
            .catch(function (err) {
            console.log(err);
        });
    };
    return { copied: copied, copyToClipboard: copyToClipboard };
};
//# sourceMappingURL=useCopyToClipboard.js.map